import React from "react";

const Footer = ({ children }) => (
  <>
    {children}
  </>
);

export default Footer;
